var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2749_16555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5116 16.3137C14.4333 17.2814 13.04 17.914 11.4865 18.0276C7.75761 18.3002 4.50238 15.4885 4.22985 11.7596C3.95732 8.03073 6.76895 4.77551 10.4978 4.50297C12.902 4.32736 15.1081 5.43482 16.4459 7.2429C17.3079 6.88165 18.1443 6.72518 18.8613 6.67262C19.5197 6.62461 20.1265 6.65986 20.6451 6.72883C18.8179 2.85197 14.7378 0.296768 10.2144 0.627334C4.34865 1.05604 -0.0747983 6.17707 0.353904 12.0428C0.782607 17.9085 5.90364 22.332 11.7694 21.9033C15.7413 21.6128 19.0512 19.1709 20.6418 15.8033C19.6555 16.2347 18.7116 16.4152 17.9234 16.4729C16.9314 16.5455 16.085 16.4337 15.5113 16.3137H15.5116Z",
    fill: "#263668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6807 8.65825L22.2815 8.4799C22.2313 8.45742 21.0336 7.92876 19.4634 7.9561C18.0479 7.98102 16.0271 8.46654 14.4405 10.6392L14.1777 10.999L15.1792 14.5744L15.6057 14.7506C15.7163 14.7962 16.7269 15.1963 18.1482 15.1714C19.5616 15.1465 21.62 14.6826 23.3996 12.6126L23.725 12.2337L22.6804 8.65764L22.6807 8.65825Z",
    fill: "#A71916"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2749_16555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogo);
export default __webpack_public_path__ + "static/media/small-logo.cf742412719898836aea0a1738d91e38.svg";
export { ForwardRef as ReactComponent };